var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useStyles } from './Receipt.styles';
import Wrapper from '../../../Components/Wrapper/Wrapper';
import Typography from '@mui/material/Typography';
import RightArrowIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import GoBack from '../../../Components/GoBack/GoBack';
import Header from '../../../Components/Header/Header';
import { format } from 'date-fns';
import { useApi } from '../../../Context/APIContext';
import useApiAbort from '../../../Api/Core/useApiAbort';
import Loading from '../../../Components/Loading';
import HTTP404 from '../../../Features/Errors/HTTP404';
import Button from '@mui/material/Button';
import { getAppConfiguration } from '../../../Config';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { sv } from 'date-fns/locale';
export const Receipt = () => {
    const { paymentReference } = useParams();
    const [vatNumber] = useState(getAppConfiguration().vatNumber);
    const classes = useStyles();
    const [receipt, setReceipt] = useState();
    const api = useApi();
    const abortController = useApiAbort();
    if (api) {
        api.setAbortController(abortController.current);
    }
    useEffect(() => {
        const fetchReceipt = () => __awaiter(void 0, void 0, void 0, function* () {
            if (api) {
                try {
                    const receipt = yield api.getReceipt(paymentReference);
                    setReceipt(receipt);
                }
                catch (exception) {
                    if (!abortController.current.signal.aborted) {
                        setReceipt(null);
                    }
                }
            }
        });
        fetchReceipt();
    }, [api, paymentReference, abortController]);
    return (React.createElement(React.Fragment, null, (receipt && (React.createElement(Wrapper, null,
        React.createElement(Box, { component: "div", sx: classes.breadcrumb },
            React.createElement(Typography, { sx: classes.breadcrumbText, variant: "h4" }, "Mina betalningar"),
            React.createElement(RightArrowIcon, null),
            React.createElement(Typography, { sx: classes.breadcrumbText, variant: "h4" }, "Kvitto")),
        React.createElement(Header, null,
            React.createElement(GoBack, { to: "/mypages/mypayments" }),
            React.createElement(Typography, { sx: classes.title, variant: "h1" },
                "Kvitto: #",
                receipt.transactionNumber)),
        React.createElement(Box, { component: "section", sx: classes.root },
            React.createElement(Box, { component: "div", sx: classes.printContainer },
                React.createElement(Button, { variant: "outlined", onClick: () => window.print(), sx: classes.button }, "Skriv ut")),
            React.createElement(Box, { component: "div", sx: classes.row },
                React.createElement(Typography, null, "Datum:"),
                React.createElement(Typography, null, format(new Date(receipt.timestamp), 'PP', { locale: sv }))),
            React.createElement(Box, { component: "div", sx: classes.row },
                React.createElement(Typography, null, "Abonnemangsnummer:"),
                React.createElement(Typography, null,
                    "#",
                    receipt.orderReference)),
            React.createElement(Box, { component: "div", sx: classes.row },
                React.createElement(Typography, null, "Betalningss\u00E4tt:"),
                React.createElement(Typography, null,
                    receipt.cardType,
                    " ",
                    receipt.paymentMethod)),
            React.createElement(Box, { component: "div", sx: classes.row },
                React.createElement(Typography, null, "\u00C5terf\u00F6rs\u00E4ljare:"),
                React.createElement(Typography, null, "Makhazin Sverige AB")),
            React.createElement(Box, { component: "div", sx: classes.row },
                React.createElement(Typography, null, "Adress:"),
                React.createElement(Typography, null, "Hen\u00E5n 402, 429 49, Orust")),
            receipt.paymentItems.map((item, index) => (React.createElement(Box, { component: "div", key: index, sx: classes.row },
                React.createElement(Typography, null, (index === 0 && 'Produkt(er):') || ''),
                React.createElement(Typography, null, item.name)))),
            React.createElement(Box, { component: "div", sx: classes.row },
                React.createElement(Typography, null,
                    "Moms (",
                    receipt.vat * 100,
                    "%):"),
                React.createElement(Typography, null,
                    receipt.totalVatAmount,
                    " ",
                    receipt.currency)),
            vatNumber && (React.createElement(Box, { component: "div", sx: classes.row },
                React.createElement(Typography, null, "VAT-nummer:"),
                React.createElement(Typography, null, vatNumber))),
            React.createElement(Box, { component: "div", sx: classes.row },
                React.createElement(Typography, null, "Summa (inkl. moms):"),
                React.createElement(Typography, null,
                    receipt.totalPrice,
                    " ",
                    receipt.currency)))))) ||
        (receipt === undefined && React.createElement(Loading, null)) || React.createElement(HTTP404, null)));
};
export default Receipt;
